import React from 'react';

const STYLES = {
  overview: 'bg-slate-100 text-slate-700',
  guide: 'bg-blue-100 text-blue-800',
  comparison: 'bg-purple-100 text-purple-800',
  tips: 'bg-emerald-100 text-emerald-800',
};

const LABELS = {
  overview: 'Overview',
  guide: 'Guide',
  comparison: 'Comparison',
  tips: 'Tips',
};

function GuideTypeBadge({ guideType, readMinutes }) {
  if (!guideType) return null;
  const style = STYLES[guideType] || STYLES.guide;
  const label = LABELS[guideType] || guideType;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-2">
      <span className={`text-xs font-semibold uppercase tracking-wide px-2 py-0.5 rounded ${style}`}>
        {label}
      </span>
      {readMinutes ? (
        <span className="text-xs text-gray-500">{readMinutes} min read</span>
      ) : null}
    </div>
  );
}

export default GuideTypeBadge;
